import React from "react"
import { Helmet } from "react-helmet"
import Phone from "../../components/Shared/Phone"
const classes = require('./WineDinner.module.scss')

const wineDinner = () => {
  return (
    <div className={classes.WineDinner}>
      <Helmet>
        <title>Waterfront Wine Pairings at Mile Marker 158 Dockside</title>
        <meta name="description" content="Check out the next wine pairing at Mile Marker 158 Dockside, located at The Wharf in Orange Beach, Alabama." />
      </Helmet>

      <div className={classes.medDef}>
        <div className={classes.menuArea}>
          <div className={classes.inside}>
            <div className={classes.titleRow}>
              <div className={classes.inner}>
                <h1>October Wine Dinner</h1>
                <h2 className={classes.bold}>
                  October 1st <br className={classes.br1}/>
                  <span className={classes.sp1}>&nbsp;&middot;&nbsp;</span> 6pm <span className={classes.sp2}>&nbsp;&middot;&nbsp;</span> $60 Per Guest
                </h2>
                <h3>Hosted by Alabama Crown Distributing</h3>
                <h4>For Reservations: <br className={classes.br400} /> <Phone where="wineDinner" /></h4>
              </div>
            </div>
          </div>

          <div className={[classes.inside, classes.stip].join(' ')}>
            <div className={classes.menuRow}>
              <div className={classes.menuBoxFull}>                
                <h5>First Course</h5>
                <h4>BBQ Shrimp &amp; Spinach Salad with Warm Bacon Vinaigrette</h4>
                <p>BBQ Shrimp, Baby Spinach, Cantaloupe, Side of Warm Bacon Vinaigrette</p>
                <p className={classes.pair}>Paired With</p>
                <h4>Allan Scott · Sauvignon Blanc · New Zealand '25</h4>
              </div>

              <div className={classes.menuBoxFull}>
                <h5>Second Course </h5>
                <h4>Lobster Macaroni</h4>
                <p>Lobster Bites Blended with Havarti, Gruyère, and Vermont Cheddar Cheese, Garganelli Pasta</p>
                <p className={classes.pair}>Paired With</p>
                <h4>Horizon de Bichot · Chardonnay · France '25</h4>
              </div>

              <div className={classes.menuBoxFull}>
                <h5>Third Course</h5>
                <h4>Roasted Elk Tenderloin</h4>
                <p>Elk Tenderloin Wrapped in Bacon, Whipped Duchess Potatoes, Grilled Zucchini</p>
                <p className={classes.pair}>Paired With</p>
                <h4>Bernier · Val de Loire Pinot Noir · France '23</h4>
              </div>

              <div className={classes.menuBoxFull}>
                <h5>Fourth Course</h5>
                <h4>Plum Tart</h4>
                <p>Flaky Homemade Tart with Fresh Plums, Vanilla Bean Ice Cream, Mint</p>
                <p className={classes.pair}>Paired With</p>
                <h4>Michele Chiarlo · Moscato d'Asti Nivole · Italy '23</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default wineDinner